 
export const NonPayment = 'Nonpayment';
export const CreditCard = 'CreditCard';
export const Check = 'Check';
export const PayPal = 'PayPal';
export const ApplePay = 'ApplePay';
export const nonPayment = 'nonPayment';
export const creditCards = 'creditCards';
export const payPal = 'payPal';
export const applePay = 'applePay';
